import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between bg-white/80 dark:bg-slate-800/80 backdrop-blur-sm rounded-2xl shadow-lg border border-slate-200/50 dark:border-slate-700/50 p-5" }
const _hoisted_2 = { class: "text-sm font-medium text-slate-500 dark:text-slate-400" }
const _hoisted_3 = { class: "mt-1 h-8 flex items-center" }
const _hoisted_4 = {
  key: 1,
  class: "text-2xl font-semibold text-slate-900 dark:text-white"
}
const _hoisted_5 = {
  key: 1,
  class: "w-6 h-6",
  "aria-hidden": "true"
}
const _hoisted_6 = ["href"]

import { computed } from 'vue'
import type { PropType, Component } from 'vue'
import PulseLoader from '@/components/common/PulseLoader.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'StatCard',
  props: {
	label: { type: String, required: true },
	value: { type: [Number, String], required: true },
	icon: { type: [String, Object] as PropType<string | Component>, required: true },
	color: { type: String, required: true },
	loading: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props

const isComponent = computed(() => typeof props.icon !== 'string')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(__props.label), 1),
      _createElementVNode("div", _hoisted_3, [
        (__props.loading)
          ? (_openBlock(), _createBlock(PulseLoader, { key: 0 }))
          : (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.value), 1))
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["flex items-center justify-center w-12 h-12 rounded-xl", __props.color])
    }, [
      (isComponent.value)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(__props.icon), {
            key: 0,
            class: "w-6 h-6"
          }))
        : (_openBlock(), _createElementBlock("svg", _hoisted_5, [
            _createElementVNode("use", { href: __props.icon }, null, 8, _hoisted_6)
          ]))
    ], 2)
  ]))
}
}

})